import { Translation } from '../types/locale';

export const translation: Translation = {
  common: {
    logoAlt: '28X Logo',
    appName: '28X',
  },
  home: {
    seo: {
      title: '28X - Private Period Tracking',
      description: 'Privacy-focused period tracking app made by women, for women',
    },
    hero: {
      privateTitle: 'PRIVATE',
      periodTitle: 'PERIOD',
      subtitle: 'Made by women, for women.',
    },
    waitlist: {
      callToAction: 'Sign up and be the first to experience 28X!',
      submitButton: 'Join 28X waiting list & updates',
      privacyNoticeLink: 'Privacy Notice',
      optInText: "By subscribing you will receive 28X app updates before launch and product news, offers and features after launch. You can unsubscribe at any time using the link in any email or by writing to info@my28x.com. ",
      emailPlaceholder: 'YOUR EMAIL',
    },
    footer: {
      dataControl: 'You control your data',
      charitySupport: "Support women's health charities",
      freeForever: '100% Free Forever',
      dataPrivacy: 'Total data privacy',
    },
  },
  waitlist: {
    confirmation: {
      whyWere: "WHY WE'RE",
      different: 'DIFFERENT',
      videoPreviewAlt: 'Video preview',
      playVideoButtonLabel: 'Play video explaining why 28X is different',
      playButtonAlt: 'Play Video',
      almostThereTitle: "YOU'RE ON THE LIST!",
      checkEmail: 'Check your email',
      excitementMessage: "We're excited to have you on this journey, empowering you to understand and track your health privately and effortlessly.",
      inviteFriends: 'Invite your friends to join 28X!',
    },
  },
  social: {
    shareWhatsapp: 'Share on WhatsApp',
    whatsappAlt: 'WhatsApp icon',
    whatsappShareText: 'Join the waiting list for the female health app of the future! 🌸',
    whatsappNotAvailable: 'WhatsApp not available on your device',
    desktopWhatsappGuide: 'On desktop? Open WhatsApp on your phone and scan the QR code to share',
    homeShareText: 'Just discovered 28X - a privacy-first period tracker that\'s FOREVER FREE! Made by women, for women. Check out the waitlist and spread the word! www.my28x.com #PeriodPrivacy',
    confirmationShareText: 'Just discovered 28X - a privacy-first period tracker that\'s FOREVER FREE! Made by women, for women. I\'ve joined the waitlist and thought you might be interested too! www.my28x.com #PeriodPrivacy',
  },
  privacy: {
    title: 'PRIVACY NOTICE',
    subtitle: 'You control your data.',
    backToHome: 'Back to Home',
    backToHomeAriaLabel: 'Return to homepage',
    companyInfo: {
      registeredName: 'Registered name: 28X LTD.',
      registrationNumber: 'Registration number 15339330',
      registeredOffice: '20 Wenlock Road, London, England, N1 7GU',
      introduction: 'This privacy notice tells you what to expect us to do with your personal information.',
    },
    navigation: {
      title: 'Navigation',
      sections: {
        contactDetails: 'Contact details',
        whatWeCollect: 'What Information We Collect and Why',
        lawfulBasis: 'Lawful Basis and Your Data Protection Rights',
        dataProtectionRights: 'Data Protection Rights',
        informationSource: 'Where we get personal information from',
        dataStorage: 'Where do we keep your information and what security is in place to protect it',
        internationalTransfers: 'International Data Transfers',
        retentionPeriod: 'How Long We Keep Your Information',
        complaints: 'How to Complain',
        changes: 'Changes to This Privacy Notice',
      },
    },
  },
  error: {
    title: 'Error',
  },
  video: {
    muxPlaybackId: '7DV5a2s7dx93rFF7hV45LTAfnEnVRpS4ovomxaXK4cY',
  },
};